/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationsEnableWebhooks } from "../funcs/organizationsEnableWebhooks.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  EnableWebhooksRequest,
  EnableWebhooksSecurity,
} from "../models/operations/enablewebhooks.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type EnableWebhooksMutationVariables = {
  request?: EnableWebhooksRequest | undefined;
  security?: EnableWebhooksSecurity | undefined;
  options?: RequestOptions;
};

export type EnableWebhooksMutationData = void;

export type EnableWebhooksMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * enableWebhooks organizations
 *
 * @remarks
 * Enable  webhooks for the active organization.
 */
export function useEnableWebhooksMutation(
  options?: MutationHookOptions<
    EnableWebhooksMutationData,
    EnableWebhooksMutationError,
    EnableWebhooksMutationVariables
  >,
): UseMutationResult<
  EnableWebhooksMutationData,
  EnableWebhooksMutationError,
  EnableWebhooksMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildEnableWebhooksMutation(client, options),
    ...options,
  });
}

export function mutationKeyEnableWebhooks(): MutationKey {
  return ["@gram/client", "organizations", "enableWebhooks"];
}

export function buildEnableWebhooksMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: EnableWebhooksMutationVariables,
  ) => Promise<EnableWebhooksMutationData>;
} {
  return {
    mutationKey: mutationKeyEnableWebhooks(),
    mutationFn: function enableWebhooksMutationFn({
      request,
      security,
      options,
    }): Promise<EnableWebhooksMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(organizationsEnableWebhooks(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
